module.exports = __webpack_public_path__ + "img/show_tc_text_7.26f14ed7.png";